// Una descarga a la vez, no un historial: el diálogo solo muestra la que está
// en curso y acumular las anteriores sería memoria que nadie lee.
const initialState = () => ({
  jobId: null,
  // Metadatos del reporte/formato que se esta exportando, fijados al arrancar.
  // Sin esto, un dialogo reabierto despues de cambiar de reporte en el
  // selector mostraria el nombre del reporte seleccionado ahora, no el que
  // en realidad se esta descargando.
  reportId: null,
  reportName: '',
  format: null,
  // queued | running | succeeded | failed — los mismos valores que persiste el backend
  status: null,
  percentComplete: 0,
  downloadUrl: null,
  // Código estable del catálogo del backend; el texto lo decide la UI
  errorCode: null,
  retryAfterSeconds: null,
  isStarting: false
})

export default initialState
